let base;
let domain = window.location.host;
let hotelType = domain.indexOf('localhost') !== -1;
base = hotelType ? 'https://test.crm.xinjngtech.com/' : location.protocol + '//' + location.host + '/';
// base = 'https://dev.crm.xinjngtech.com/'
export default base;



// WEBPACK FOOTER //
// ./src/api/baseUrl.js